import './env-config';
import React from 'react';
import './honeycomb';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Provider as LoggingProvider, ErrorBoundary } from '@rollbar/react';
import App from './App';
import { AuthProvider } from './context/AuthProvider';

const rollbarConfig = {
  accessToken: window.env.REACT_APP_ROLLBAR_ACCESS_TOKEN,
  environment: window.env.REACT_APP_NODE_ENV,
  enabled: ['development', 'staging', 'production'].includes(window.env.REACT_APP_NODE_ENV),
};

// eslint-disable-next-line no-undef
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <LoggingProvider config={rollbarConfig}>
        <ErrorBoundary>
          <AuthProvider>
            <Routes>
              <Route
                path="/*"
                element={<App />}
              />
            </Routes>
          </AuthProvider>
        </ErrorBoundary>
      </LoggingProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
